module.exports = {"pickpack":{"titlePick":"Pick","titlePack":"Pack","pick":"Pick","pack":"Pack","toDelivery":"Delivery"}}


//////////////////
// WEBPACK FOOTER
// ./src/wording/language/en/pickpack.json
// module id = 554
// module chunks = 35